import React, { useState, useEffect } from "react";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import {
  useGetAllEmployeesPaginated,
  useGetAllJobGrades,
} from "../../hooks/useUsers";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import CheckboxInput from "../../components/Reusable/CheckboxInput";
import SelectableItemInput from "../../components/Reusable/SelectableItemInput";
import WeeklyShiftSchedule from "../../components/Reusable/WeeklyShiftSchedule";
import {
  useCreateShift,
  useGetShiftById,
  useUpdateShift,
} from "../../hooks/useShiftSchedules";
import {
  useCreateWorkLocation,
  useGetWorkLocationById,
  useUpdateWorkLocation,
} from "../../hooks/useWorkLocations";
import { LocationPicker } from "../../components/Reusable/LocationPicker";

function AddWorkLocationLayout() {
  const [isEditUser, setIsEditUser] = useState(false);
  const [editUserID, setEditUserID] = useState(null);

  const [editedFields, setEditedFields] = useState({});

  const createWorkLocation = useCreateWorkLocation();
  const updateWorkLocation = useUpdateWorkLocation();

  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data: _workLocationData,
    isLoading: _workLocationDataIsLoading,
    isError: _workLocationDataIsError,
  } = useGetWorkLocationById(id);

  useEffect(() => {
    if (id) {
      setIsEditUser(true);
      setEditUserID(id);
    }
  }, []);

  useEffect(() => {
    if (_workLocationData?.success && _workLocationData?.data) {
      const record = {
        ..._workLocationData.data,
      };

      setWorkLocation(record);
    }
  }, [_workLocationData]);

  const handleSubmitWorkLocation = async () => {
    if (isEditUser) {
      updateWorkLocation.mutate(
        { id, payload: editedFields },
        {
          onSuccess: (data) => {
            toast.success(data.message);
            navigate("/WorkLocations");
          },
        }
      );
    } else {
      createWorkLocation.mutate(workLocation, {
        onSuccess: async (data) => {
          if (data.success) {
            toast.success(data.message);
            navigate("/WorkLocations");
          }
        },
      });
    }
  };
  const handleChange = (field, value) => {
    setWorkLocation((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (isEditUser) {
      setEditedFields((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const isSubmitDisabled = isEditUser && Object.keys(editedFields).length === 0;

  const [workLocation, setWorkLocation] = useState({
    Name: "Main Office - Quezon City",
    Address: "123 Commonwealth Avenue, Diliman",
    City: "Quezon City",
    Province: "Metro Manila",
    PostalCode: "1101",
    Country: "Philippines",
    Longitude: 121.0583,
    Latitude: 14.6519,
  });

  return (
    <div className="add-user-page">
      <div className="form-container">
        <h2>{isEditUser ? "Edit" : "Add"} Work Location</h2>

        <form className="add-user-form">
          <div className="form-row">
            <TextInput
              label="Name"
              placeholder="Name"
              value={workLocation.Name}
              onChange={(val) => handleChange("Name", val)}
            />
          </div>
          <div className="form-row">
            <TextInput
              label="Postal Code"
              placeholder="1234"
              value={workLocation.PostalCode}
              onChange={(val) => handleChange("PostalCode", val)}
            />
          </div>
          <section>
            <LocationPicker value={workLocation} onChange={setWorkLocation} />
          </section>
          <div className="form-actions">
            <button
              type="button"
              disabled={isSubmitDisabled}
              onClick={handleSubmitWorkLocation}
            >
              Submit Work Location
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddWorkLocationLayout;
